import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Organization } from "@/hooks/useOrganizations";
import OrganizationsMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect";
import BaseFilters from "@/components/v2/molecules/admin/shared/BaseFilters";

interface PropertiesFiltersProps {
  searchTerm: string;
  selectedOrganizations: string[];
  availabilityFilter: string;
  onSearchChange: (value: string) => void;
  onOrganizationsChange: (value: string[]) => void;
  onAvailabilityChange: (value: string) => void;
  organizations: Organization[];
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

const PropertiesFilters = ({
  searchTerm,
  selectedOrganizations,
  availabilityFilter,
  onSearchChange,
  onOrganizationsChange,
  onAvailabilityChange,
  organizations,
  hasActiveFilters,
  onClearFilters,
}: PropertiesFiltersProps) => (
  <BaseFilters
    searchTerm={searchTerm}
    onSearchChange={onSearchChange}
    searchPlaceholder="Buscar propiedad..."
    searchWidth="w-[200px]"
    hasActiveFilters={hasActiveFilters}
    onClearFilters={onClearFilters}
    hideDatePicker
  >
    <OrganizationsMultiSelect
      organizations={organizations}
      selectedOrganizations={selectedOrganizations}
      onSelectionChange={onOrganizationsChange}
    />

    <Select value={availabilityFilter} onValueChange={onAvailabilityChange}>
      <SelectTrigger className="w-[180px] rounded-full bg-muted/50 hover:bg-muted transition-colors border-0">
        <SelectValue placeholder="Todas las propiedades" />
      </SelectTrigger>
      <SelectContent className="bg-background z-50">
        <SelectItem value="all">Todas</SelectItem>
        <SelectItem value="available">Disponibles</SelectItem>
        <SelectItem value="unavailable">No disponibles</SelectItem>
        <SelectItem value="featured">Destacadas</SelectItem>
      </SelectContent>
    </Select>
  </BaseFilters>
);

export default PropertiesFilters;

